import Angular from "angular";
import Controller from "./duration.controller";

export default Angular.module('duration', [])
    .component('duration', {
        template: '{{$ctrl.duration}}',
        controller: Controller,
        bindings: {
            durationFormat: '<',
            durationMinutes: '<',
            durationStart: '<',
            durationEnd: '<'
        }
    })



// WEBPACK FOOTER //
// ./src/modules/core/components/duration/duration.js